<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper" class="scrollbar">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in menuRouters"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/style/variables.scss";
import { constantRoutes } from '@/router'

export default {
  components: { SidebarItem, Logo },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([ "sidebar", 'currentUser', 'currentRole']),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.app.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
    menuRouters() {
      const role = this.currentRole
      if (!role) return constantRoutes

      return constantRoutes.map(item => {
        const copy = { ...item }

        // 先过滤子路由（根据 child.hidden 和 child.meta.roles）
        if (copy.children && copy.children.length) {
          copy.children = copy.children.filter(child => {
            if (child.hidden) return false
            if (child.meta?.roles) {
              return child.meta.roles.includes(role)
            }
            return true
          })
        }

        // 如果有可见的子路由，保留父路由（无视父级 meta.roles）
        if (copy.children && copy.children.length) {
          return copy
        }

        // 没有可见子路由，则依据父级 meta.roles 决定是否展示父路由（或展示为单项）
        if (item.meta?.roles) {
          return item.meta.roles.includes(role) ? copy : null
        }

        return copy
      }).filter(Boolean)
    }
  },
};
</script>
<style scoped lang="scss">
.scrollbar {
  box-shadow: 1px 0 4px rgb(0 21 41 / 8%);
  margin-right: 6px;
  padding-top: 16px;
}
</style>
